import { useMemo, useState } from "react";
import { knowledgeDocuments, meetings } from "../../data/alessandroWorkspace";

export function MeetingsKnowledge() {
  const [selectedId, setSelectedId] = useState(meetings.at(-1)?.id ?? meetings[0].id);
  const selected = useMemo(() => meetings.find((meeting) => meeting.id === selectedId) ?? meetings[0], [selectedId]);
  const recordings = meetings.reduce((total, meeting) => total + meeting.recordings.length, 0);
  const notes = meetings.reduce((total, meeting) => total + meeting.notes.length, 0);

  return (
    <section className="intel-view meetings-view">
      <div className="intel-section-intro meetings-intro">
        <span>CALENDAR → RECORDINGS → DECISIONS</span>
        <h2>Four calls turned into operating memory.</h2>
        <p>Every meeting preserves its source files, the evolution of the demand, commercial signals, decisions and two-sided commitments.</p>
      </div>

      <div className="meeting-summary-cards">
        <article><span>CALLS FOUND</span><b>4</b><small>17–22 August 2026</small></article>
        <article><span>RECORDINGS</span><b>{recordings}</b><small>Google Drive video files</small></article>
        <article><span>GEMINI NOTES</span><b>{notes}</b><small>English + Portuguese</small></article>
        <article><span>DEMAND EVOLUTION</span><b>APP → FDE</b><small>application to revenue infrastructure</small></article>
      </div>

      <div className="meetings-layout">
        <aside className="meeting-timeline" aria-label="Meeting timeline">
          {meetings.map((meeting, index) => (
            <button key={meeting.id} className={selected.id === meeting.id ? "active" : ""} onClick={() => setSelectedId(meeting.id)}>
              <span>{meeting.shortDate}<i /></span>
              <div><small>CALL {String(index + 1).padStart(2, "0")} · {meeting.phase}</small><b>{meeting.title}</b><p>{meeting.duration} · {meeting.confidence} confidence</p></div>
            </button>
          ))}
        </aside>

        <article className="meeting-detail">
          <header>
            <div><span>{selected.date} · {selected.phase}</span><h2>{selected.title}</h2></div>
            <strong>{selected.duration}</strong>
          </header>
          <div className="meeting-outcome"><span>PRIMARY OUTCOME</span><p>{selected.outcome}</p></div>
          <p className="meeting-summary">{selected.summary}</p>

          <div className="meeting-signals">
            {selected.signals.map((signal) => <div key={signal.label}><span>{signal.label}</span><b>{signal.value}</b><small className={`evidence-${signal.level}`}>{signal.level.replaceAll("_", " ")}</small></div>)}
          </div>

          <div className="meeting-detail-grid">
            <section><h3>Decisions</h3><ul>{selected.decisions.map((item) => <li key={item}>{item}</li>)}</ul></section>
            <section><h3>Client commitments</h3><ul>{selected.clientActions.map((item) => <li key={item}>{item}</li>)}</ul></section>
            <section><h3>Automatrix commitments</h3><ul>{selected.automatrixActions.map((item) => <li key={item}>{item}</li>)}</ul></section>
            <section><h3>Platforms mentioned / observed</h3><div className="meeting-platforms">{selected.platforms.map((platform) => <span key={platform}>{platform}</span>)}</div></section>
          </div>

          <footer className="meeting-evidence">
            <div><span>RECORDINGS</span>{selected.recordings.map((item) => <a key={item.url} href={item.url} target="_blank" rel="noreferrer">▶ {item.title} ↗</a>)}</div>
            <div><span>MEETING NOTES</span>{selected.notes.map((item) => <a key={item.url} href={item.url} target="_blank" rel="noreferrer">▤ {item.language} ↗</a>)}</div>
          </footer>
        </article>
      </div>

      <article className="intel-panel knowledge-library">
        <header><div><span>KNOWLEDGE BASE</span><h3>Documents that define the project</h3></div><small>Drive, analysis and operating playbooks</small></header>
        <div>{knowledgeDocuments.map((document) => <a key={document.title} href={document.url} target={document.url.startsWith("http") ? "_blank" : undefined} rel="noreferrer">
          <span>{document.type}</span><h4>{document.title}</h4><p>{document.description}</p><footer><b>{document.state}</b><i>↗</i></footer>
        </a>)}</div>
      </article>
    </section>
  );
}
